import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=2d7949ad&"
import script from "./UserPreferences.vue?vue&type=script&lang=js&"
export * from "./UserPreferences.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2d7949ad', component.options)
    } else {
      api.reload('2d7949ad', component.options)
    }
    module.hot.accept("./UserPreferences.vue?vue&type=template&id=2d7949ad&", function () {
      api.rerender('2d7949ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserPreferences.vue"
export default component.exports